import CustomDrawer from 'components/commom/CustomDrawer';
import { useEffect, useRef, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Checkbox, CircularProgress, IconButton } from '@mui/material';
import LabelWithInput from 'components/commom/LabelWithPracticeInput';
import 'assets/styles/common.scss';
import SelectInput from 'components/commom/SelectInput';
import { useDispatch, useSelector } from 'react-redux';
import CommonToast from 'components/commom/CommonToast';
import { useNavigate } from 'react-router-dom';
import { getDoctorDrop } from 'store/getDoctorListDropdown/getDoctorListDropdownAction';
import { ClearTokenRedirectLogin } from 'utils/general';
import { createLocationCallAPI } from 'store/EnterpriseAdmin/Location/createLocation/action';
import { updateLocationCallAPI } from 'store/EnterpriseAdmin/Location/updateLocation/action';
import AddIcon from '@mui/icons-material/Add';
import { Image } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ReusableTabs from 'components/commom/Tab';
import UploadFileIcon from '@mui/icons-material/UploadFile';

const ImportProduct = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const [formValue, setFormValue] = useState({
    tab: 1,
    shelf: '',
    overwrite: false,
    link: '',
    currency: '',
    file: null,
  });
  const [formSlug, setFormSlug] = useState({});
  const csvInputRef = useRef(null);

  const enterpriseData = useSelector(
    (state) => state?.getEnterpriseProfileReducer?.users?.data
  );

  const importProductData = [
    { id: 1, label: 'Shopify' },
    { id: 2, label: 'Standard' },
  ];

  useEffect(() => {
    if (open) {
      initialState();
    }
  }, [open]);

  const initialState = () => {
    // setFormValue({});
    // setFormSlug({});
  };

  const handleBack = () => {
    onClose();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChange = (e) => {
    const { name, checked } = e.target;
    setFormValue((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleTabChange = (val) => {
    setFormValue((prev) => ({
      ...prev,
      ['tab']: val,
    }));
    // const tab = productInventoryData[val - 1];
    // setFormValue((prev) => ({
    //   ...prev,
    //   ['tab']: val,
    //   ['productInventory']: tab,
    // }));
  };

  const handleSave = () => {
    // if (
    //   !formValue?.address ||
    //   !formValue?.city ||
    //   !formValue?.state ||
    //   !formValue?.country ||
    //   !formValue?.postalCode
    // ) {
    //   showToast('Please fill all the required fields', 'error');
    //   return;
    // }
    // const body = {
    //   id: editData?.id,
    //   detail: {
    //     name: formValue?.locationName
    //       ? formValue?.locationName
    //       : enterpriseData?.enterprise?.enterprise_name,
    //     address: formValue?.address,
    //     city: formValue?.city,
    //     state: formValue?.state,
    //     country: formValue?.country,
    //     postal_code: formValue?.postalCode,
    //   },
    //   enterpriseId: enterpriseData?.enterprise?.enterprise_id,
    // };
    // if (editData?.id) {
    //   dispatch(
    //     updateLocationCallAPI(body, {
    //       run: true,
    //       handleFunction: (res) => {
    //         showToast(res?.message, 'success');
    //         handleBack();
    //       },
    //       authorize: true,
    //       handleAuthorizeFunction: (res) => {
    //         ClearTokenRedirectLogin(navigate);
    //       },
    //       error: true,
    //       handleErrorFunction: (res) => {
    //         showToast(res?.message, 'error');
    //       },
    //     })
    //   );
    // } else {
    //   dispatch(
    //     createLocationCallAPI(body, {
    //       run: true,
    //       handleFunction: (res) => {
    //         showToast(res?.message, 'success');
    //         handleBack();
    //       },
    //       authorize: true,
    //       handleAuthorizeFunction: (res) => {
    //         ClearTokenRedirectLogin(navigate);
    //       },
    //       error: true,
    //       handleErrorFunction: (res) => {
    //         showToast(res?.message, 'error');
    //       },
    //     })
    //   );
    // }
  };

  console.log('formValue', formValue);

  return (
    <CustomDrawer
      open={open}
      onClose={() => {
        handleBack();
      }}
      width={{ xs: '100vw', md: '70vw', xl: '40vw' }}
    >
      <div className="relative h-full min-h-[400px] flex flex-col">
        <div className="flex-1 overflow-y-auto p-[25px] pb-[15%]">
          <div className="mt-[43px]">
            <div className="flex items-center justify-between gap-[20px]">
              <p className="p-0 m-0 text-[24px] text-[#292D32] family_outfit_semiBold_600 lh-176">
                Import Products
              </p>
              <IconButton onClick={handleBack}>
                <CloseIcon />
              </IconButton>
            </div>
            <div className="mt-[24px]">
              <ReusableTabs
                tabs={importProductData}
                defaultTab={formValue?.tab}
                currentTab={(val) => handleTabChange(val)}
                background={'#864629'}
                color={'#FFFFFF'}
                tabColor={'#A2A2A2'}
                completeColor={'#FFFFFF'}
                boxShadow={'0px 3px 16px 0px #00000014'}
              />
            </div>
            <div className="mt-[40px]">
              <div>
                <SelectInput
                  label={<>Select shelf</>}
                  placeholder={'Shelf'}
                  colorIcon={'#292D32'}
                  name={'shelf'}
                  value={formValue?.shelf}
                  data={[]}
                  onChange={handleInputChange}
                />
              </div>
              <div className="mt-[16px] flex items-center gap-[2px]">
                <Checkbox
                  name={'overwrite'}
                  onChange={handleChange}
                  sx={{
                    color: '#864629',
                    '&.Mui-checked': {
                      color: '#864629',
                    },
                    '&:hover': {
                      backgroundColor: 'rgba(134, 70, 41, 0.08)',
                    },
                  }}
                  checked={formValue?.overwrite}
                />
                <div className="text-[16px] lh-201 family_outfit_regular_400 text-[#737373]">
                  {'Overwrite existing products'}
                </div>
              </div>
              {formValue?.tab === 1 && (
                <>
                  <div className="mt-[16px]">
                    <LabelWithInput
                      label={<>Your store url</>}
                      placeholder="Url"
                      name="link"
                      type="text"
                      value={formValue?.link}
                      onChange={(e) => handleInputChange(e)}
                    />
                  </div>
                  <div className="mt-[16px]">
                    <SelectInput
                      label={<>Currency</>}
                      placeholder={'Currency'}
                      colorIcon={'#292D32'}
                      name={'currency'}
                      value={formValue?.currency}
                      data={[]}
                      onChange={handleInputChange}
                    />
                  </div>
                </>
              )}
              {formValue?.tab === 2 && (
                <>
                  <div className="mt-[16px]">
                    <div className="text-[14px] lh-201 family_outfit_regular_400 fc-292D32">
                      Example:{' '}
                      <span className="text-[#874529] underline cursor-pointer">
                        Import file
                      </span>{' '}
                      or{' '}
                      <span className="text-[#874529] underline cursor-pointer">
                        import with minimum fields
                      </span>
                    </div>
                  </div>
                  <div
                    className="mt-[16px] border-1 border-[#A4AAB2] border-dashed h-[124px] rounded-[12px] flex flex-col items-center justify-center cursor-pointer"
                    onClick={() => csvInputRef.current?.click()}
                  >
                    <input
                      ref={csvInputRef}
                      type="file"
                      accept=".csv"
                      className="hidden"
                      onChange={(e) => {
                        console.log(e.target.files);
                        const file = e.target.files[0];
                        if (file) setFormValue((prev) => ({ ...prev, file }));
                      }}
                    />
                    <UploadFileIcon />
                    <div className="mt-[5px] text-[14px] lh-201 family_outfit_regular_400 text-[#737373]">
                      {formValue?.file
                        ? formValue.file.name
                        : 'Upload CSV File'}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        {/* Absolutely Positioned Bottom Button */}
        <div
          className="mt-[30px] absolute left-0 bottom-0 w-full bg-[#375241] p-[30px] cursor-pointer"
          onClick={() => {
            handleSave();
          }}
        >
          <div className="text-[24px] text-white family_outfit_semiBold_600 lh-176 text-center flex items-center justify-center gap-[10px]">
            {'Import'}
            {false ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              <span
                style={{ width: 24, height: 24, display: 'inline-block' }}
              />
            )}
          </div>
        </div>
      </div>
    </CustomDrawer>
  );
};

export default ImportProduct;
